// extracted by mini-css-extract-plugin
export default {"subMove":"SubAnalysisMove_subMove__0kJwk"};